import { render, staticRenderFns } from "./Bridge.vue?vue&type=template&id=00833ada&scoped=true&"
import script from "./Bridge.vue?vue&type=script&lang=ts&"
export * from "./Bridge.vue?vue&type=script&lang=ts&"
import style0 from "./Bridge.vue?vue&type=style&index=0&id=00833ada&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00833ada",
  null
  
)

export default component.exports